import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { KeycloakService } from 'src/app/auth/keycloak.service';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { QuickActions } from '../../services/quick-actions';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'ara-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, PageLayoutComponent, PageLayoutHeaderDirective, MatIcon],
})
export class DashboardComponent implements OnInit {
	private readonly translocoService = inject(TranslocoService);
	private readonly translocoLocaleService = inject(TranslocoLocaleService);
	private readonly keycloak = inject(KeycloakService);

	private readonly quickActions = inject(QuickActions);
	private readonly router = inject(Router);

	firstName = '';
	lastName = '';

	ngOnInit(): void {
		this.initAsync();
	}

	setLanguage(language: string): void {
		this.translocoService.setActiveLang(language);
		this.translocoLocaleService.setLocale(this.translocoService.getActiveLang());
	}

	protected newTenantChange(): void {
		this.quickActions.openTenantChange();
	}

	protected newVacancyChange(): void {
		this.quickActions.openVacancyChange();
	}

	protected changeUviPermission(): void {
		this.quickActions.changeUviPermission();
	}

	protected activateRealEstate(): void {
		this.router.navigate(['/permissions']);
	}

	private async initAsync(): Promise<void> {
		const isLoggedIn = await this.keycloak.isLoggedIn();
		if (isLoggedIn) {
			await this.keycloak.loadUserProfile();
		}
		const selectedDeviceIdString = sessionStorage.getItem('selectedDeviceId');
		if (selectedDeviceIdString?.length !== 36) {
			sessionStorage.setItem('selectedDeviceId', '');
		}
		sessionStorage.setItem('selectedRealEstateID', '');
		sessionStorage.setItem('selectedTenantUnitID', '');
		sessionStorage.setItem('activeView', window.location.href);
		this.readName();
	}

	private readName(): void {
		const keycloakToken = this.keycloak.getKeycloakInstance().tokenParsed;
		this.firstName = keycloakToken['given_name'];
		this.lastName = keycloakToken['family_name'];
	}
}
